<template>
  <div>
    <b-alert class="text-center" :show="!datas.length" variant="danger">Data is empty</b-alert>
    <GmapMap style="width: 100%; height: 350px;" :zoom="5" :center="{lat: -2.096719, lng: 107.935055}" ref="map" v-if="datas.length">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        <div class="text-center" v-html="infoContent"></div>
      </gmap-info-window>

      <gmap-marker
        :key="i"
        v-for="(m,i) in markers"
        :position="m.latLng"
        :clickable="true"
        @click="toggleInfoWindow(m,i)">
      </gmap-marker>
      <!-- <gmap-custom-marker v-for="(m, index) in markers" :key="index" :marker="m.latLng">
        <span class="badge p-1" :class="{'badge-success':m.status > 0, 'badge-secondary': m.status < 1}" v-b-tooltip.hover :title="m.title">
          <i class="fa fa-user-o"></i>
        </span>
      </gmap-custom-marker> -->
    </GmapMap>
  </div>
</template>
<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
  name: 'user-geo-stats',
  data () {
    return {
      markers: [],
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
    }
  },
  components: {
      'gmap-custom-marker': GmapCustomMarker
  },
  props: ['datas'],
  methods: {
    toggleInfoWindow(marker, idx) {
      this.infoContent = ''
      this.infoWindowPos = marker.latLng
      this.infoContent += `<span class="d-block">${marker.fullName}</span>`
      this.infoContent += `<span class="d-block">${marker.userName}</span>`
      this.infoContent += `<span class="d-block">${marker.status > 0 ? 'Active' : 'Inactive'}</span>`
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  },
  mounted () {
    this.datas.forEach(data => {
      if (data.LAT !== null) {
        this.markers.push(
          {
            latLng: {
              lat: parseFloat(data.LAT),
              lng: parseFloat(data.LNG)
            },
            label: {text: data.STATUS > 0 ? 'Active' : 'Inactive'},
            userName: data.USER_NAME,
            fullName: data.FULL_NAME,
            status: data.STATUS
          }
        )
      }
    })
  }
}
</script>
